<template><!-- svgo-optimised -->
<svg class="icon icon__arrow icon__arrow--plp-left-arrow" viewBox="0 0 9 13" xmlns="http://www.w3.org/2000/svg"><path d="M8.56 12.652.93 7.18c-.226-.162-.226-.432 0-.603l7.393-5.3" stroke="#2A2422" stroke-miterlimit="10"/></svg>
 </template>